import { atom } from 'recoil'

export const signupStepState = atom<number>({
  key: 'signupStepState',
  default: 1,
})
